import type { SetupTourDefinition, SetupTourStep } from '../core/types';

const allowPageInteractionStyles: NonNullable<SetupTourStep['styles']> = {
  clickArea: (base) => ({ ...base, pointerEvents: 'none' }),
};

export const STATIONS_SETUP_TOUR_TARGETS = {
  sidebarStationsLink: 'stations-sidebar-link',
  addStationButton: 'stations-list-add-button',
  createForm: 'stations-create-form',
  saveContinueButton: 'stations-save-continue-button',
  feesPanel: 'stations-fees-panel',
} as const;

export const stationsSetupTour: SetupTourDefinition = {
  id: 'stations_setup',
  label: 'Stations Setup',
  onboardingKey: 'stations_setup',
  sidebarTargetsByRoute: {
    '/stations': STATIONS_SETUP_TOUR_TARGETS.sidebarStationsLink,
  },
  steps: [
    {
      id: 'open-stations',
      route: '/stations',
      target: STATIONS_SETUP_TOUR_TARGETS.sidebarStationsLink,
      content:
        'Click Stations in the sidebar to set up operational stations such as Rethymno, Athens, or Thessaloniki',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/pricing'],
    },
    {
      id: 'add-station',
      route: '/stations',
      target: STATIONS_SETUP_TOUR_TARGETS.addStationButton,
      content: 'Click Add Station to create your first station',
      advanceOnTargetClick: true,
    },
    {
      id: 'station-form',
      route: '/stations/create',
      target: STATIONS_SETUP_TOUR_TARGETS.createForm,
      content:
        'Complete the required station details. Click Next when all required fields are complete.',
      showRequiredFieldsOnEnter: true,
      next: {
        guardTarget: STATIONS_SETUP_TOUR_TARGETS.createForm,
      },
    },
    {
      id: 'save-station',
      route: '/stations/create',
      target: STATIONS_SETUP_TOUR_TARGETS.saveContinueButton,
      content: 'Click Save & Continue to create the station and set up its fees',
      directNextTargets: [STATIONS_SETUP_TOUR_TARGETS.saveContinueButton],
      next: {
        action: { type: 'click' },
        waitForTargetRemoval: STATIONS_SETUP_TOUR_TARGETS.saveContinueButton,
      },
    },
    {
      id: 'station-fees',
      route: '/stations/:id/fees',
      target: STATIONS_SETUP_TOUR_TARGETS.feesPanel,
      highlightTarget: STATIONS_SETUP_TOUR_TARGETS.feesPanel,
      content:
        'A new station is Unavailable in every cell. Click a cell to set its pick-up and drop-off, or use Bulk Edit to set many cells at once. Each cell saves on its own.',
      navigateOnEnter: false,
      hidePrevious: true,
      next: { label: 'Done', completesTour: true },
      styles: allowPageInteractionStyles,
    },
  ],
};
